/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { CompanyFragmentFragmentDoc } from './companyFragment.generated';
import { CompanyServicesFragmentFragmentDoc } from './companyServicesFragment.generated';
import { AdditionalCompanyInfoFragmentFragmentDoc } from './additionalCompanyInfoFragment.generated';
import { UserFragmentFragmentDoc } from './userFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Brand_Enum =
  /** G20 */
  | 'G20'
  /** Auchan Hyper */
  | 'auchan_hyper'
  /** Auchan MyAuchan */
  | 'auchan_myauchan'
  /** Auchan Super */
  | 'auchan_super'
  /** Biocoop */
  | 'biocoop'
  /** Carrefour City */
  | 'carrefour_city'
  /** Carrefour Contact */
  | 'carrefour_contact'
  /** Carrefour Express */
  | 'carrefour_express'
  /** Carrefour Hyper */
  | 'carrefour_hyper'
  /** Carrefour Market */
  | 'carrefour_market'
  /** Coccimarket */
  | 'coccimarket'
  /** Coccimarket City */
  | 'coccimarket_city'
  /** Coccimarket Easy */
  | 'coccimarket_easy'
  /** Cora */
  | 'cora'
  /** Diago */
  | 'diago'
  /** E.Leclerc */
  | 'e_leclerc'
  /** E.Leclerc Express */
  | 'e_leclerc_express'
  /** Franprix */
  | 'franprix'
  /** Hyper U */
  | 'hyper_u'
  /** Intermarché Contact */
  | 'intermarche_contact'
  /** Intermarché Express */
  | 'intermarche_express'
  /** Intermarché Hyper */
  | 'intermarche_hyper'
  /** Intermarché Super */
  | 'intermarche_super'
  /** Monop’ */
  | 'monop'
  /** Monoprix */
  | 'monoprix'
  /** Netto */
  | 'netto'
  /** Sitis Market */
  | 'sitis_market'
  /** Spar */
  | 'spar'
  /** Super U */
  | 'super_u'
  /** U Express */
  | 'u_express'
  /** Utile */
  | 'utile';

export type Business_Profile_Enum =
  | 'BUYER'
  | 'SUPPLIER';

export type Global_Product_Family_Enum =
  | 'ALL'
  | 'NONE';

export type Marketing_Support_Enum =
  | 'FURNITURE'
  | 'OTHER'
  /** English acronym for 'PLV' */
  | 'POS';

export type Minimum_Order_Value_Type_Enum =
  | 'PACKAGING'
  | 'PRICE'
  | 'WEIGHT';

export type Privacy_Setting_Enum =
  | 'CONTRACTUALIZED'
  | 'EVERYONE'
  | 'NOBODY';

export type Product_Family_Name_Enum =
  | 'BEVERAGES'
  | 'FRESH_FOOD'
  | 'GROCERY'
  | 'NON_FOOD_PRODUCTS';

export type Product_Sub_Family_Name_Enum =
  | 'BAKERY'
  | 'BEER_CIDER'
  | 'CLOTHING_TEXTILE'
  | 'DAIRY'
  | 'DELI'
  | 'FISH_SEAFOOD'
  | 'FLORAL'
  | 'FROZEN_FOOD'
  | 'FRUITS'
  /**   */
  | 'GAMES_TOYS'
  | 'HOUSEHOLD_CLEANING'
  | 'HYGIENE_BEAUTY'
  | 'NON_ALCOHOLIC_BEVERAGES'
  | 'PETS'
  | 'RAW_MEAT'
  | 'SALTY_GROCERY'
  | 'SPIRITS'
  | 'SWEET_GROCERY'
  | 'VEGETABLES'
  | 'VEGETARIAN_VEGAN'
  | 'WINE_CHAMPAGNE_SPARKLING';

export type Return_Policy_Enum =
  | 'FULL'
  | 'PARTIAL';

export type Staff_Role_Enum =
  | 'ADMIN';

export type User_Role_Enum =
  | 'BUYER_DIRECTOR'
  | 'BUYER_FINANCE'
  | 'BUYER_MANAGER'
  | 'BUYER_OWNER'
  | 'COMPANY_ADMIN'
  | 'STAFF_ADMIN'
  | 'SUPPLIER_OWNER'
  | 'SUPPLIER_SALES_ADMIN'
  | 'SUPPLIER_SALES_REP';

export type CompanyContextFragmentFragment = { legalName: string, supplier_commission_rate: number | null, invoice_prefix: string, id: string, business_profile: Types.Business_Profile_Enum, description: string | null, contactEmail: string, contactPhoneNumber: string, tradeName: string, brand: Types.Brand_Enum | null, provide_marketing: boolean | null, marketing_details: string | null, provide_animation: boolean | null, animation_details: string | null, provide_electrical_appliance: boolean | null, electrical_appliance_details: string | null, provide_return_policy: boolean | null, return_policy: Types.Return_Policy_Enum | null, return_policy_details: string | null, provide_merchandising: boolean | null, merchandising_details: string | null, delivery_description: string | null, delivery_instructions: string | null, delivery_email: string | null, delivery_phone_number: string | null, invoicing_instructions: string | null, invoicing_email: string | null, invoicing_phone_number: string | null, addresses: Array<{ longitude: number, latitude: number, formattedAddress: string, locality: string | null, postalCode: string | null, postalTown: string | null, countryCode: string, administrativeAreaLevel2: string | null }>, role_assignments: Array<{ id: string, is_delivery_contact: boolean, is_invoicing_contact: boolean, userId: string, user: { email: string, id: string, first_name: string, last_name: string, auth_provider_avatar_url: string | null, default_avatar: { domain: string | null, path: string } | null } }>, photos: Array<{ photo: { path: string, domain: string | null } }>, marketing_supports: Array<{ support: Types.Marketing_Support_Enum }>, delivery_zones: Array<{ id: string, index: number, minimum_order_value: number, minimum_order_value_type: Types.Minimum_Order_Value_Type_Enum, negotiable_minimum_order_value: boolean, delivery_time: number | null, administrative_areas: Array<{ area: string }> }>, delivery_hours: Array<{ id: string, opening_hour: string, closing_hour: string, week_day: string }>, delivery_address: { id: string, address_1: string, address_2: string | null, postal_code: string, city: string, country: string, name: string } | null, invoicing_address: { id: string, address_1: string, address_2: string | null, postal_code: string, city: string, country: string, name: string } | null };

export type UserRoleQueryVariables = Exact<{
  id: string;
  companyId?: string | null | undefined;
  hasCompanyId: boolean;
}>;


export type UserRoleQuery = { user_by_pk: { email: string, mobile_phone: string | null, mobile_privacy_setting: Types.Privacy_Setting_Enum | null, landline_phone: string | null, landline_privacy_setting: Types.Privacy_Setting_Enum | null, email_privacy_setting: Types.Privacy_Setting_Enum | null, id: string, first_name: string, last_name: string, auth_provider_avatar_url: string | null, staff_user: { role: Types.Staff_Role_Enum } | null, role_assignments: Array<{ id: string, role_name: Types.User_Role_Enum | null, company: { legalName: string, supplier_commission_rate: number | null, invoice_prefix: string, id: string, business_profile: Types.Business_Profile_Enum, description: string | null, contactEmail: string, contactPhoneNumber: string, tradeName: string, brand: Types.Brand_Enum | null, provide_marketing: boolean | null, marketing_details: string | null, provide_animation: boolean | null, animation_details: string | null, provide_electrical_appliance: boolean | null, electrical_appliance_details: string | null, provide_return_policy: boolean | null, return_policy: Types.Return_Policy_Enum | null, return_policy_details: string | null, provide_merchandising: boolean | null, merchandising_details: string | null, delivery_description: string | null, delivery_instructions: string | null, delivery_email: string | null, delivery_phone_number: string | null, invoicing_instructions: string | null, invoicing_email: string | null, invoicing_phone_number: string | null, addresses: Array<{ longitude: number, latitude: number, formattedAddress: string, locality: string | null, postalCode: string | null, postalTown: string | null, countryCode: string, administrativeAreaLevel2: string | null }>, role_assignments: Array<{ id: string, is_delivery_contact: boolean, is_invoicing_contact: boolean, userId: string, user: { email: string, id: string, first_name: string, last_name: string, auth_provider_avatar_url: string | null, default_avatar: { domain: string | null, path: string } | null } }>, photos: Array<{ photo: { path: string, domain: string | null } }>, marketing_supports: Array<{ support: Types.Marketing_Support_Enum }>, delivery_zones: Array<{ id: string, index: number, minimum_order_value: number, minimum_order_value_type: Types.Minimum_Order_Value_Type_Enum, negotiable_minimum_order_value: boolean, delivery_time: number | null, administrative_areas: Array<{ area: string }> }>, delivery_hours: Array<{ id: string, opening_hour: string, closing_hour: string, week_day: string }>, delivery_address: { id: string, address_1: string, address_2: string | null, postal_code: string, city: string, country: string, name: string } | null, invoicing_address: { id: string, address_1: string, address_2: string | null, postal_code: string, city: string, country: string, name: string } | null } | null, product_families: Array<{ global_setting: Types.Global_Product_Family_Enum | null, product_family: Types.Product_Family_Name_Enum | null, product_sub_family: Types.Product_Sub_Family_Name_Enum | null }>, brands: Array<{ brand: Types.Brand_Enum | null, has_all_brands: boolean | null }>, administrative_areas: Array<{ area: string | null, country_code: string | null, has_all_areas: boolean | null }> }>, default_avatar: { domain: string | null, path: string } | null } | null, company?: Array<{ legalName: string, supplier_commission_rate: number | null, invoice_prefix: string, id: string, business_profile: Types.Business_Profile_Enum, description: string | null, contactEmail: string, contactPhoneNumber: string, tradeName: string, brand: Types.Brand_Enum | null, provide_marketing: boolean | null, marketing_details: string | null, provide_animation: boolean | null, animation_details: string | null, provide_electrical_appliance: boolean | null, electrical_appliance_details: string | null, provide_return_policy: boolean | null, return_policy: Types.Return_Policy_Enum | null, return_policy_details: string | null, provide_merchandising: boolean | null, merchandising_details: string | null, delivery_description: string | null, delivery_instructions: string | null, delivery_email: string | null, delivery_phone_number: string | null, invoicing_instructions: string | null, invoicing_email: string | null, invoicing_phone_number: string | null, addresses: Array<{ longitude: number, latitude: number, formattedAddress: string, locality: string | null, postalCode: string | null, postalTown: string | null, countryCode: string, administrativeAreaLevel2: string | null }>, role_assignments: Array<{ id: string, is_delivery_contact: boolean, is_invoicing_contact: boolean, userId: string, user: { email: string, id: string, first_name: string, last_name: string, auth_provider_avatar_url: string | null, default_avatar: { domain: string | null, path: string } | null } }>, photos: Array<{ photo: { path: string, domain: string | null } }>, marketing_supports: Array<{ support: Types.Marketing_Support_Enum }>, delivery_zones: Array<{ id: string, index: number, minimum_order_value: number, minimum_order_value_type: Types.Minimum_Order_Value_Type_Enum, negotiable_minimum_order_value: boolean, delivery_time: number | null, administrative_areas: Array<{ area: string }> }>, delivery_hours: Array<{ id: string, opening_hour: string, closing_hour: string, week_day: string }>, delivery_address: { id: string, address_1: string, address_2: string | null, postal_code: string, city: string, country: string, name: string } | null, invoicing_address: { id: string, address_1: string, address_2: string | null, postal_code: string, city: string, country: string, name: string } | null }> };

export const CompanyContextFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment companyContextFragment on company {
  ...companyFragment
  ...companyServicesFragment
  ...additionalCompanyInfoFragment
  legalName
  addresses {
    longitude
    latitude
    formattedAddress
    locality
    postalCode
    postalTown
    countryCode
    administrativeAreaLevel2
  }
  supplier_commission_rate
  invoice_prefix
  role_assignments {
    id
    is_delivery_contact
    is_invoicing_contact
    userId
    user {
      ...userFragment
      email
    }
  }
}
    ${CompanyFragmentFragmentDoc}
${CompanyServicesFragmentFragmentDoc}
${AdditionalCompanyInfoFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;
export const UserRoleDocument = /*#__PURE__*/ gql`
    query userRole($id: uuid!, $companyId: uuid, $hasCompanyId: Boolean!) {
  user_by_pk(id: $id) {
    ...userFragment
    email
    staff_user {
      role
    }
    role_assignments {
      id
      role_name
      company {
        ...companyContextFragment
      }
      product_families {
        global_setting
        product_family
        product_sub_family
      }
      brands {
        brand
        has_all_brands
      }
      administrative_areas {
        area
        country_code
        has_all_areas
      }
    }
    mobile_phone
    mobile_privacy_setting
    landline_phone
    landline_privacy_setting
    email_privacy_setting
  }
  company(where: {id: {_eq: $companyId}}) @include(if: $hasCompanyId) {
    ...companyContextFragment
  }
}
    ${UserFragmentFragmentDoc}
${CompanyContextFragmentFragmentDoc}`;

/**
 * __useUserRoleQuery__
 *
 * To run a query within a React component, call `useUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      hasCompanyId: // value for 'hasCompanyId'
 *   },
 * });
 */
export function useUserRoleQuery(baseOptions: Apollo.QueryHookOptions<UserRoleQuery, UserRoleQueryVariables> & ({ variables: UserRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRoleQuery, UserRoleQueryVariables>(UserRoleDocument, options);
      }
export function useUserRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRoleQuery, UserRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRoleQuery, UserRoleQueryVariables>(UserRoleDocument, options);
        }
// @ts-ignore
export function useUserRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserRoleQuery, UserRoleQueryVariables>): Apollo.UseSuspenseQueryResult<UserRoleQuery, UserRoleQueryVariables>;
export function useUserRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRoleQuery, UserRoleQueryVariables>): Apollo.UseSuspenseQueryResult<UserRoleQuery | undefined, UserRoleQueryVariables>;
export function useUserRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRoleQuery, UserRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserRoleQuery, UserRoleQueryVariables>(UserRoleDocument, options);
        }
export type UserRoleQueryHookResult = ReturnType<typeof useUserRoleQuery>;
export type UserRoleLazyQueryHookResult = ReturnType<typeof useUserRoleLazyQuery>;
export type UserRoleSuspenseQueryHookResult = ReturnType<typeof useUserRoleSuspenseQuery>;
export type UserRoleQueryResult = Apollo.QueryResult<UserRoleQuery, UserRoleQueryVariables>;